<template>
  <div class="grid grid-cols-5 mt-3">
    <div class="col-start-3 col-span-5">
      <api-call-placeholder
        :focus="focus"
        :error="isErrorBubbleFocused && actionId === error.actionId"
        @click="selectRemoteBubble" />
    </div>
  </div>
</template>

<script>
import chatBubbleModule from '@/store/modules/chat-bubble.module'
import previewModule from '@/store/modules/preview.module'
import ApiCallPlaceholder from '@/components/common/ApiCallPlaceholder'

export default {
  name: 'RemoteBubble',
  components: { ApiCallPlaceholder },

  props: {
    stateId: { type: String, required: true },
    actionId: { type: String, required: true },
    isTemplate: { type: Boolean, required: true },
    focus: { type: Boolean, required: true },
    inNestedCondition: { type: Boolean, default: false }
  },

  computed: {
    bubbleSelected: chatBubbleModule.bubbleSelected,
    error: previewModule.error,

    isErrorBubbleFocused() {
      return chatBubbleModule.isErrorBubbleFocused()
    }
  },

  methods: {
    selectRemoteBubble() {
      chatBubbleModule.selectRemoteBubble(this.stateId, this.actionId, this.isTemplate, this.inNestedCondition)
    }
  }
}
</script>

